import QRCode from "react-qr-code";

const QrCode = (props) => {

    return (    
    <div style={{ height: "auto", margin: "0 auto", maxWidth: 125, width: "100%", marginTop: '30px' , marginBottom: '30px'}}>
        
        <QRCode
            size={325}
            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            value={props.value}
            viewBox={`0 0 325 325`}
        />
        </div>)
}

export default QrCode;